export default __webpack_public_path__ + "static/media/modern-components-dark-large.c920fe78.png";